<template>
	<div>
		<div class="title-container">
			<div class="title">{{ orders.length }} Order{{ orders.length !== 1 ? 's' : '' }}</div>
		</div>
		<div class="input-container">
			<div class="input-title">Filter By Status</div>
			<div class="input-box">
				<selectize v-model="form.status" :settings="{ create: false }" placeholder="Choose Filter">
					<option value="0">Any</option>
					<option v-for="(orders, status) in ordersByStatus" :key="`order-status-option-${ status }`" :value="status">{{ (status || '').toLowerCase() | capitalize }} ({{ orders.length }})</option>
				</selectize>
			</div>
		</div>
		<div class="search-container">
			<div class="search-box"><input type="text" v-model="search" placeholder="Search"></div>
				<div class="search-icon"><span class="fa fa-search"></span></div>
		</div>
		<div v-if="filteredOrders.length !== orders.length " class="search-results">
			<div class="results">Found <span>{{ filteredOrders.length }}</span> Result{{ filteredOrders.length !== 1 ? 's' : '' }}</div>
			<div class="cancel-button"><a href @click.prevent="resetSearch">Clear Search<span class="fa fa-times"></span></a></div>
		</div>
		<nothing-here v-if="filteredOrders.length === 0" :is-filtered="!!search"></nothing-here>
		<div class="table list">
			<div v-if="filteredOrders.length > 0" class="row sortable">
				<div class="cell"><a href @click.prevent="sortByColumn('created_at')" :class="headerColumnClass('created_at')">Ordered On<span v-if="sort.column === 'created_at'" class="fa" :class="sort.direction === 'asc' ? 'fa-angle-down' : 'fa-angle-up'"></span></a></div>
				<div class="cell"><a href @click.prevent="sortByColumn('shipping_recipient')" :class="headerColumnClass('shipping_recipient')">Customer<span v-if="sort.column === 'shipping_recipient'" class="fa" :class="sort.direction === 'asc' ? 'fa-angle-down' : 'fa-angle-up'"></span></a></div>
				<div class="cell"><a href @click.prevent="sortByColumn('order_total')" :class="headerColumnClass('order_total')">Order Total<span v-if="sort.column === 'order_total'" class="fa" :class="sort.direction === 'asc' ? 'fa-angle-down' : 'fa-angle-up'"></span></a></div>
				<div class="cell"><a href @click.prevent="sortByColumn('status')" :class="headerColumnClass('status')">Status<span v-if="sort.column === 'status'" class="fa" :class="sort.direction === 'asc' ? 'fa-angle-down' : 'fa-angle-up'"></span></a></div>
				<div class="cell"></div>
			</div>
			<order-list-item v-for="order in filteredOrders" :key="`order-${ order.id }`" :order="order"></order-list-item>
		</div>
	</div>
</template>


<script>

import _ from 'underscore';
import moment from 'moment-timezone';
import { mapGetters } from 'vuex';
import OrderListItem from './components/OrderListItem';
import SortableList from '@/mixins/SortableList';

export default {

	name: 'OrdersListPage',

	mixins: [ SortableList ],

	async asyncData({ app, store, redirect }) {
		try {
			const [ listPayload, orderPayload ] = await Promise.all([
				app.$api.get(`/module/orders/list`),
				app.$api.get('/commerce/orders'),
			]);

			store.dispatch('setActiveModule', listPayload.data.module);
			store.commit('setHeaderButtons', listPayload.data.boilerplate.buttons);
			store.commit('setPageData', listPayload.data.boilerplate.page);
			store.commit('setHeaderTags', { fields: listPayload.data.boilerplate.tagFields, numTags: listPayload.data.boilerplate.numTags });
			store.commit('setNavCount', { slug: listPayload.data.module.slug, count: listPayload.data.rows.length });

			return {
				orders: orderPayload.data.data,
				boilerplate: listPayload.data.boilerplate,
			};
		} catch (e) {
			console.log('bad!', e);
			if (e.response && e.response.status) {
				switch (e.response.status) {
					case 403:
						store.dispatch('errorToast', 'You do not have access to that section');
						break;
					default:
						store.dispatch('errorToast', 'There was an error loading that section');
						break;
				}
			}
			return redirect('/dashboard');
		}
	},

	data() {
		return {
			orders: [],
			search: '',
			sort: {
				column: 'created_at',
				direction: 'desc',
			},
			form: {
				status: '0',
			},
		};
	},

	computed: {

		...mapGetters(['module', 'moduleHeader']),

		filteredOrders() {
			const search = (!this.search || this.search.length === 0) ? null :this.search.toLowerCase();

			return this.sortedOrders.filter(order => {
				if (search) {
					const fields = ['shipping_recipient', 'stripe_customer_id', 'stripe_charge_id'];
					const matches = fields.filter(field => {
						return (order[ field ] || '').toLowerCase().indexOf(search) !== -1;
					});

					if (!matches.length) return false;
				}

				if (this.form.status != 0) {
					return order.status === this.form.status;
				}

				return true;
			});
		},

		sortedOrders() {
			if (this.sort.column !== false && this.sort.direction !== false) {
				let sorted = _.sortBy(this.orders, (row) => {
					// Sort based on field type
					switch (this.sort.column) {
						case 'created_at':
							return moment(row[ this.sort.column ]).valueOf();
						default:
							if (typeof row[ this.sort.column ] === 'string') {
								return row[ this.sort.column ].toLowerCase();
							}
							return row[ this.sort.column ];
					}
				});

				if (this.sort.direction === 'desc') {
					sorted = sorted.reverse();
				}

				return sorted;
			}

			return this.orders;
		},

		ordersByStatus() {
			return _.groupBy(this.orders, 'status');
		},

	},

	methods: {

		resetSearch() {
			this.search = '';
			this.form = { status: '0' };
		},

	},

	components: {
		OrderListItem,
	},

};

</script>
